'use strict';

var React = require('react'),
    ShareLink = require('./ShareLink'),
    ShareActionCreators = require('../actions/ShareActionCreators'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes } = React;

var ShareZineLink = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    zine: PropTypes.object.isRequired,
    service: PropTypes.any.isRequired,
    propagateClick: PropTypes.bool
  },

  contextTypes: {
    source: React.PropTypes.string.isRequired
  },

  render() {
    return (
      <ShareLink service={this.props.service}
                 onClick={this.handleClick}
                 propagateClick={this.props.propagateClick}
                 context={this.props.context}
                 underline={this.props.underline}
                 bold={this.props.bold} />
    );
  },

  handleClick() {
    var {
      service,
      zine: { slug: zineSlug }
    } = this.props;

    ShareActionCreators.shareZine({
      zineSlug: zineSlug,
      service: service,
      source: this.context.source
    });
  }
});

module.exports = ShareZineLink;



/** WEBPACK FOOTER **
 ** ./atoms/ShareZineLink.jsx
 **/